<template>
  <v-hover v-slot:default="{ hover }">
    <v-card :elevation="hover ? 12 : 2">
      <router-link :to="isAddOn(id)? getAddOnData(id).to : { name: 'game', params: slug ? { game: id, slug } : { game: id } }">
        <v-img v-if="banner" :src="banner" height="280px" style="border-radius: 4px">
          <template v-slot:placeholder>
            <v-skeleton-loader type="image"/>
          </template>
        </v-img>
      </router-link>
    </v-card>
  </v-hover>
</template>
<script>
export default {
  props: {
    id: {
      required: true
    },
    name: {
      required: true
    },
    banner: {
      required: true
    },
    slug: {
      required: false,
      default: ''
    }
  },

  data() {
    return {
      addOns: ['lottery', 'e-game-american-roulette-3d', 'sports-bet'],
      addOnsData: {
        'lottery': {
          to: {name: 'user.lottery.create-ticket', params: {game: 'lottery'}}
        },
        'e-game-american-roulette-3d': {
          to: {name: 'e-games.american-roulette-3d', params: {game: 'e-game-american-roulette-3d'}}
        },
        'sports-bet': {
          to: {name: 'user.sports-bet.matches', params: {game: 'sports-bet'}}
        },
      }
    }
  },
  methods: {
    isAddOn(addOnId) {
      return this.addOns.includes(addOnId)
    },
    getAddOnData(addOnId) {
      return this.addOnsData[addOnId]
    }
  }
}
</script>
<style>
.container {
  background-color: transparent;
}
</style>
